import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import moment from "moment";

export default class SearchQueryInfo extends Component {
  render() {
    return [
      <hr key="hr" />,
      <div key="query-info" className="row-fluid search-query-info">
        <div className="span6">
          <FormattedMessage id="search_timestamp" />
          {this.props.timestamp
            ? moment(this.props.timestamp).format("YYYY-MM-DD HH:mm:ss")
            : null}
        </div>
        <div className="span6">
          <FormattedMessage
            id="searchResults"
            values={{
              display: this.props.numDisplayedRecords,
              total: this.props.numTotalRecords
            }}
          />
        </div>
      </div>
    ];

    // Don't display anything
  }
}
